<template>
  <div class="app-container">
    <el-form :model="search" :inline="true" label-position="right" ref="search">
      <el-form-item label="旧机品牌" prop="status">
        <el-select
          v-model="search.brand"
          placeholder="请选择"
          clearable
          style="width: 100%"
        >
          <el-option label="格力品牌" value="GREE"> </el-option>
          <el-option label="非格力品牌" value="OTHER"> </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="row-bg">
      <el-button type="primary" size="medium" @click="exportExcel()"
        >导出</el-button
      >
      <el-button type="primary" size="medium" @click="importExcel()"
        >导入</el-button
      >
      <el-button type="primary" size="medium" @click="handleSearch()"
        >查询</el-button
      >
      <el-button size="medium" @click="resetForm">重置</el-button>
    </div>
    <el-table
      ref="checktableData"
      :data="list"
      v-loading="listLoading"
      :reserve-selection="true"
      center
      height="60vh"
    >
      <el-table-column label="编号" prop="number" width="180"></el-table-column>
      <el-table-column label="旧机品牌" prop="brand" width="180">
        <template slot-scope="scope">{{
          scope.row.brand === "GREE" ? "格力" : "非格力"
        }}</template>
      </el-table-column>
      <el-table-column
        label="旧机品类"
        prop="category"
        width="180"
      ></el-table-column>
      <el-table-column label="旧机规格" prop="specification" width="180">
        <template slot-scope="scope">{{
          scope.row.specification + scope.row.model
        }}</template>
      </el-table-column>
      <el-table-column label="价格" prop="price" width="180"></el-table-column>
      <el-table-column
        label="1米铜管"
        prop="meterCopperPrice"
        width="180"
      ></el-table-column>
      <el-table-column
        label="1米铝管"
        prop="meterAluminumPrice"
        width="180"
      ></el-table-column>
      <el-table-column
        label="无-大阀门"
        prop="bigValve"
        width="180"
      ></el-table-column>
      <el-table-column
        label="无-小阀门"
        prop="smallValve"
        width="180"
      ></el-table-column>
      <el-table-column
        label="无-外机风叶"
        prop="exWindBlade"
        width="180"
      ></el-table-column>
      <el-table-column
        label="无-内机风叶"
        prop="inWindBlade"
        width="180"
      ></el-table-column>
      <el-table-column
        label="无-外机电机"
        prop="exElectricalMachinery"
        width="180"
      ></el-table-column>
      <el-table-column
        label="无-内机电机"
        prop="inElectricalMachinery"
        width="180"
      ></el-table-column>
      <el-table-column
        label="无-外机外罩"
        prop="exCover"
        width="180"
      ></el-table-column>
      <el-table-column
        label="无-外机顶板/底板"
        prop="exBoard"
        width="180"
      ></el-table-column>
      <el-table-column
        label="无-内机面板"
        prop="internalPanel"
        width="180"
      ></el-table-column>
      <el-table-column
        label="无-电源线"
        prop="powerLine"
        width="180"
      ></el-table-column>
      <el-table-column
        label="操作人"
        prop="lastModifiedBy"
        width="180"
      ></el-table-column>
      <el-table-column
        label="更新时间"
        prop="lastModifiedDate"
        width="180"
      ></el-table-column>

      <el-table-column label="操作" fixed="right" width="200" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="goEdit(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes,prev, pager, next,jumper"
        :current-page.sync="search.page"
        :page-size="search.rows"
        :page-sizes="[10, 20]"
        :total="total"
      >
      </el-pagination>
    </div>
    <editOldValuation
      ref="editOldValuationRef"
      @opera-success="getList"
    ></editOldValuation>
    <importOldValuation
      ref="importOldValuationRef"
      @opera-success="handleSearch"
    ></importOldValuation>
  </div>
</template>
<script>
import editOldValuation from "./components/editOldValuation";
import importOldValuation from "./components/importOldValuation";

import { getOldMachinePrice } from "@/api/oldValuation";

export default {
  name: "oldValuation",
  components: {
    editOldValuation,
    importOldValuation,
  },
  filters: {},

  data() {
    return {
      list: [],
      total: 0, //列表总条数
      listLoading: false,
      search: {
        brand: null, //品牌
        page: 1, //当前页
        rows: 10,
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    handleSearch() {
      this.search.page = 1;
      this.getList();
    },
    async getList() {
      let { data, statusCode, total } = await getOldMachinePrice(this.search);

      if (statusCode == 200) {
        this.list = data;
        this.total = total;
      }
    },
    resetForm() {
      this.search = this.$options.data().search;
    },

    handleSizeChange(val) {
      this.search.page = 1;
      this.search.rows = val;
      this.getList();
    },
    handleCurrentChange() {
      this.getList();
    },

    async goEdit(rowData) {
      this.$refs.editOldValuationRef.openDialog(rowData);
    },
    // 导入
    importExcel() {
      this.$refs.importOldValuationRef.openDialog();
    },
    //导出
    exportExcel() {

      let url = `/autoapp-default-server-recovery/api/oldMachinePrice/export`;
      this.HttpService.post(url, this.search).then(res => {
        if (res.statusCode == 200) {
          this.$message.success('正在导出, 稍后请到下载中心查看')
        } else {
          this.$message.warning(res.message)
        }
      })
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.goodsStyle {
  display: flex;
  align-items: center;
}
.flex {
  display: flex;
  align-items: center;
  // margin: 0 20px;
  padding: 0 20px;
  span {
    min-width: 100px;
  }
}
.row-bg {
  margin-bottom: 15px;
}
.btnBox {
  margin-bottom: 20px;
}
.data-view-wrap {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-start;
  .item-wrap {
    margin-right: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #00b882;
    padding: 10px;
    height: auto;
    color: #fff;

    .unit {
      margin-left: 20px;
      max-width: 300px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      > span {
        font-size: 20px;
        padding-right: 5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/oldForNewService/oldValuation.vue